// automatically generated by the FlatBuffers compiler, do not modify

import { ElevatorGroupSupervisoryStatusMessage } from "../group-supervisory-status/elevator-group-supervisory-status-message";
import { EscalatorGroupSupervisoryStatusMessage } from "../group-supervisory-status/escalator-group-supervisory-status-message";

export enum DeviceGroupSupervisoryStatusContent {
	NONE = 0,
	ElevatorGroupSupervisoryStatusMessage = 1,
	EscalatorGroupSupervisoryStatusMessage = 2,
}

export function unionToDeviceGroupSupervisoryStatusContent(
	type: DeviceGroupSupervisoryStatusContent,
	accessor: (
		obj: ElevatorGroupSupervisoryStatusMessage | EscalatorGroupSupervisoryStatusMessage
	) => ElevatorGroupSupervisoryStatusMessage | EscalatorGroupSupervisoryStatusMessage | null
): ElevatorGroupSupervisoryStatusMessage | EscalatorGroupSupervisoryStatusMessage | null {
	switch (DeviceGroupSupervisoryStatusContent[type]) {
		case "NONE":
			return null;
		case "ElevatorGroupSupervisoryStatusMessage":
			return accessor(new ElevatorGroupSupervisoryStatusMessage())! as ElevatorGroupSupervisoryStatusMessage;
		case "EscalatorGroupSupervisoryStatusMessage":
			return accessor(new EscalatorGroupSupervisoryStatusMessage())! as EscalatorGroupSupervisoryStatusMessage;
		default:
			return null;
	}
}

export function unionListToDeviceGroupSupervisoryStatusContent(
	type: DeviceGroupSupervisoryStatusContent,
	accessor: (
		index: number,
		obj: ElevatorGroupSupervisoryStatusMessage | EscalatorGroupSupervisoryStatusMessage
	) => ElevatorGroupSupervisoryStatusMessage | EscalatorGroupSupervisoryStatusMessage | null,
	index: number
): ElevatorGroupSupervisoryStatusMessage | EscalatorGroupSupervisoryStatusMessage | null {
	switch (DeviceGroupSupervisoryStatusContent[type]) {
		case "NONE":
			return null;
		case "ElevatorGroupSupervisoryStatusMessage":
			return accessor(index, new ElevatorGroupSupervisoryStatusMessage())! as ElevatorGroupSupervisoryStatusMessage;
		case "EscalatorGroupSupervisoryStatusMessage":
			return accessor(index, new EscalatorGroupSupervisoryStatusMessage())! as EscalatorGroupSupervisoryStatusMessage;
		default:
			return null;
	}
}
